import {useState} from 'react'
import {
  Badge, Modal, InfoRow,formatDate, formatDateTime, formatINR,
} from "../../../Component/Workshop/UI";
import { customerPaymentDone, STATUS_CFG } from './ClaimsPage';

function ClaimDetailModal({ claim, onClose, onClaimNo, onStatus, onAmounts, onNotify, onPayRecv,onPayWorkshop,onCustPay, onSettle, onClose: onCloseCase, onNavigate }) {
  const [tab, setTab] = useState("Overview");
  const cfg = STATUS_CFG[claim.claimStatus] || STATUS_CFG.NO_CLAIM;
  const s   = claim.claimStatus;
  const custDone = customerPaymentDone(claim);
  const canNotify  = claim.customerDue != null && !["NO_CLAIM","REJECTED","CASE_CLOSED"].includes(s);
  const canPayRecv = s === "PAYMENT_REQUESTED";

  return (
    <Modal open={!!claim} onClose={onClose} title="Claim Details" maxWidth={620}
      footer={
        <div style={{ display:"flex", justifyContent:"space-between", width:"100%", alignItems:"center" }}>
          <button className="wd-btn wd-btn-ghost wd-btn-sm"
            onClick={() => { onClose(); onNavigate(`/admin/cases/${claim.caseNo}`); }}>
            View Case →
          </button>
          <div style={{ display:"flex", gap:8 }}>
            <button className="wd-btn wd-btn-ghost" onClick={onClose}>Close</button>
            <button className="wd-btn wd-btn-primary" onClick={onStatus}>Update Status</button>
          </div>
        </div>
      }
    >
      {/* Header */}
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
        <div>
          <div style={{ fontFamily:"var(--wd-mono)", fontSize:16, fontWeight:800, color:"var(--wd-blue)" }}>{claim.caseNo}</div>
          <div style={{ fontWeight:600, fontSize:14, marginTop:2 }}>{claim.customerName}</div>
          <div style={{ fontSize:12, color:"var(--wd-t3)", marginTop:1 }}>{claim.vehicleNo} · {claim.insuranceCompany}</div>
        </div>
        <div style={{ textAlign:"right" }}>
          <Badge variant={cfg.variant}>{cfg.label}</Badge>
          {claim.claimNumber && (
            <div style={{ fontFamily:"var(--wd-mono)", fontSize:11, color:"var(--wd-t3)", marginTop:4 }}>{claim.claimNumber}</div>
          )}
        </div>
      </div>

      {/* Tabs */}
      <div style={{ display:"flex", borderBottom:"1px solid var(--wd-border)" }}>
        {["Overview","Amounts","Status Timeline"].map(t => (
          <button key={t} className={`wd-detail-tab ${tab === t ? "active" : ""}`} onClick={() => setTab(t)}>{t}</button>
        ))}
      </div>

      {/* Tab: Overview */}
      {tab === "Overview" && (
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
          <InfoRow label="Customer"          value={claim.customerName} />
          <InfoRow label="Phone"             value={claim.customerPhone} mono />
          <InfoRow label="Email"             value={claim.customerEmail} />
          <InfoRow label="Vehicle"           value={claim.vehicleNo} mono />
          <InfoRow label="Policy No"         value={claim.policyNo} mono />
          <InfoRow label="Claim No"          value={claim.claimNumber || "Not added yet"} mono />
          <InfoRow label="Insurance Co"      value={claim.insuranceCompany} />
          <InfoRow label="Workshop"          value={claim.workshopName || "Not assigned"} />
          <InfoRow label="Last Checked"      value={claim.lastStatusCheckedAt ? formatDateTime(claim.lastStatusCheckedAt) : "Never"} />
          <InfoRow label="Approved On"       value={claim.claimApprovedAt    ? formatDateTime(claim.claimApprovedAt)    : "—"} />
          <InfoRow label="Customer Notified" value={claim.customerNotified   ? "Yes ✓" : "No"} />
          <InfoRow label="Cust. Payment"     value={custDone ? (claim.customerDue === 0 ? "NIL (no due)" : `✓ Collected ${claim.customerPaidAt ? "on "+formatDate(claim.customerPaidAt) : ""}`) : "Pending"} />
        </div>
      )}

      {/* Tab: Amounts */}
      {tab === "Amounts" && (
        <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
          {[
            ["Workshop Estimate",  claim.estimateAmount,   "var(--wd-t1)"    ],
            ["Insurance Approved", claim.insApprovedAmount,   "var(--wd-green)" ],
            ["Workshop Discount",  claim.workshopDiscount, "var(--wd-teal)"  ],
            ["Customer Due",       claim.customerDue,      claim.customerDue === 0 ? "var(--wd-green)" : "var(--wd-orange)"],
            ["Ins. Amount Paid",        claim.paidAmount,       "var(--wd-blue)"  ],
          ].map(([label, val, color]) => (
            <div key={label} style={{ display:"flex", justifyContent:"space-between", padding:"10px 14px", background:"var(--wd-hover)", borderRadius:8 }}>
              <span style={{ fontSize:13, color:"var(--wd-t2)" }}>{label}</span>
              <span style={{ fontFamily:"var(--wd-mono)", fontWeight:700, fontSize:14, color }}>
                {val != null ? (val === 0 && label === "Customer Due" ? "NIL" : formatINR(val)) : "—"}
              </span>
            </div>
          ))}
          
             {/* ── Customer payment section ── */}
          <div style={{ height:1, background:"var(--wd-border)" }} />

          <div style={{
            padding:"12px 14px", borderRadius:10,
            background: custDone ? "rgba(34,197,94,.06)" : "rgba(249,115,22,.06)",
            border:`1px solid ${custDone ? "rgba(34,197,94,.2)" : "rgba(249,115,22,.2)"}`,
          }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:custDone ? 6 : 0 }}>
              <div>
                <div style={{ fontSize:12, fontWeight:700, color:custDone ? "var(--wd-green)" : "var(--wd-orange)" }}>
                  {custDone ? "✓ Customer Payment Collected" : "👤 Customer Payment"}
                </div>
                {custDone && claim.customerPaidAt && (
                  <div style={{ fontSize:11, color:"var(--wd-t3)", marginTop:2 }}>
                    {formatINR(claim.customerPaidAmount)} collected on {formatDate(claim.customerPaidAt)}
                  </div>
                )}
                {!custDone && claim.customerDue > 0 && (
                  <div style={{ fontSize:11, color:"var(--wd-t3)", marginTop:2 }}>
                    {claim.customerNotified ? "Customer has been notified — awaiting payment" : "Customer not yet notified"}
                  </div>
                )}
                {claim.customerDue === 0 && (
                  <div style={{ fontSize:11, color:"var(--wd-t3)", marginTop:2 }}>No amount due from customer</div>
                )}
              </div>
              <div style={{ fontFamily:"var(--wd-mono)", fontSize:16, fontWeight:800, color:custDone ? "var(--wd-green)" : "var(--wd-orange)" }}>
                {claim.customerDue === 0 ? "NIL" : formatINR(claim.customerDue)}
              </div>
            </div>
            {!custDone && claim.customerDue > 0 && !["SETTLED","CASE_CLOSED","REJECTED"].includes(s) && (
              <div style={{ display:"flex", gap:8, marginTop:10 }}>
                {!claim.customerNotified && (
                  <button className="wd-btn wd-btn-sm" onClick={onNotify}
                    style={{ background:"rgba(249,115,22,.1)", color:"var(--wd-orange)", border:"1px solid rgba(249,115,22,.3)", fontSize:11 }}>
                    📧 Notify Customer First
                  </button>
                )}
                {claim.customerNotified && (
                  <button className="wd-btn wd-btn-sm" onClick={onCustPay}
                    style={{ background:"rgba(249,115,22,.15)", color:"var(--wd-orange)", border:"1px solid rgba(249,115,22,.3)", fontSize:11, fontWeight:600 }}>
                    💵 Mark Customer Paid
                  </button>
                )}
              </div>
            )}
          </div>
 
          {/* ── Insurance & Workshop payment actions (existing) ── */}

          <div style={{ height:1, background:"var(--wd-border)" }} />

          {!["SETTLED","CASE_CLOSED","REJECTED"].includes(s) && (
            <button className="wd-btn wd-btn-ghost wd-btn-sm" onClick={onAmounts} style={{ justifyContent:"center" }}>
              ✏️ {claim.insApprovedAmount ? "Edit Amounts" : "Enter Approved Amount & Discount"}
            </button>
          )}

          {canNotify && (
            <button className="wd-btn wd-btn-primary" onClick={onNotify} style={{ justifyContent:"center" }}>
              📧 {claim.customerNotified ? "Resend Payment Details to Customer" : "Send Payment Details to Customer"}
            </button>
          )}
          {claim.customerNotified && (
            <div style={{ fontSize:12, color:"var(--wd-green)", textAlign:"center", padding:"8px 0" }}>
              ✓ Customer was notified · <span style={{ color:"var(--wd-t3)" }}>You can resend anytime</span>
            </div>
          )}

          {canPayRecv && (
            <button className="wd-btn wd-btn-sm" onClick={onPayRecv}
              style={{ justifyContent:"center", background:"rgba(34,197,94,.1)", color:"var(--wd-green)", border:"1px solid rgba(34,197,94,.3)" }}>
              ✓ Mark Payment Received from Insurance
            </button>
          )}

          {["PAYMENT_RECEIVED","SETTLED","CASE_CLOSED"].includes(s) && claim.paidAmount > 0 && (
            <div style={{ display:"flex", gap:10, padding:"10px 14px", background:"rgba(34,197,94,.07)", borderRadius:10, border:"1px solid rgba(34,197,94,.2)" }}>
              <span>✅</span>
              <div style={{ fontSize:12, color:"var(--wd-green)" }}>
                Payment of <strong style={{ fontFamily:"var(--wd-mono)" }}>{formatINR(claim.paidAmount)}</strong> received from {claim.insuranceCompany}
                {claim.paymentReceivedAt && <span style={{ color:"var(--wd-t3)" }}> on {formatDateTime(claim.paymentReceivedAt)}</span>}
              </div>
            </div>
          )}
          {/* Workshop payment */}
          {["PAYMENT_RECEIVED", "SETTLED"].includes(s) && claim.workshopPaymentStatus !== "PAID" && (
            <button className="wd-btn wd-btn-sm" onClick={onPayWorkshop}
            style={{ justifyContent:"center", background:"rgba(234,179,8,.1)", color:"var(--wd-yellow)", border:"1px solid rgba(234,179,8,.3)", fontWeight:600 }}>
            🏭 Pay Workshop
          </button>
          )}

          {["PAYMENT_RECEIVED", "SETTLED"].includes(s) && claim.workshopPaymentStatus === "PAID" && (
          <div style={{ display:"flex", gap:10, padding:"10px 14px", background:"rgba(234,179,8,.07)", borderRadius:10, border:"1px solid rgba(234,179,8,.2)" }}>
            <span>✅</span>
            <div style={{ fontSize:12, color:"var(--wd-yellow)" }}>
             Workshop payment paid to <strong>{claim.workshopName}</strong>
            </div>
          </div>
          )}

          {s === "PAYMENT_RECEIVED" && (
            <button className="wd-btn wd-btn-sm" onClick={onSettle}
              style={{ justifyContent:"center", background:"rgba(34,197,94,.12)", color:"var(--wd-green)", border:"1px solid rgba(34,197,94,.3)", fontWeight:600 }}>
              ✓ Settle Claim
            </button>
          )}

          {["SETTLED","CASE_CLOSED"].includes(s) && claim.settledAt && (
            <div style={{ display:"flex", gap:10, padding:"10px 14px", background:"rgba(20,184,166,.07)", borderRadius:10, border:"1px solid rgba(20,184,166,.2)" }}>
              <span>🤝</span>
              <div style={{ fontSize:12, color:"var(--wd-teal)" }}>
                Claim settled on <strong>{formatDate(claim.settledAt)}</strong>
              </div>
            </div>
          )}

          {s === "SETTLED" && (
            <button className="wd-btn wd-btn-sm" onClick={onCloseCase}
              style={{ justifyContent:"center", background:"rgba(168,85,247,.12)", color:"var(--wd-purple)", border:"1px solid rgba(168,85,247,.3)", fontWeight:600 }}>
              🔒 Close Case
            </button>
          )}

          {s === "CASE_CLOSED" && claim.closedAt && (
            <div style={{ display:"flex", gap:10, padding:"10px 14px", background:"rgba(168,85,247,.07)", borderRadius:10, border:"1px solid rgba(168,85,247,.2)" }}>
              <span>🔒</span>
              <div style={{ fontSize:12, color:"var(--wd-purple)" }}>
                Case closed on <strong>{formatDate(claim.closedAt)}</strong>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Tab: Status Timeline */}
      {tab === "Status Timeline" && (
        <div style={{ display:"flex", flexDirection:"column" }}>
          {(claim.statusHistory || []).length === 0 && (
            <div style={{ fontSize:13, color:"var(--wd-t3)", textAlign:"center", padding:20 }}>No history yet</div>
          )}
          {[...(claim.statusHistory || [])].reverse().map((e, i, arr) => {
            const c = STATUS_CFG[e.status];
            const isLatest = i === 0;
            const dotColor = c?.variant === "red"    ? "var(--wd-red)"
                           : c?.variant === "green"  ? "var(--wd-green)"
                           : c?.variant === "yellow" ? "var(--wd-yellow)"
                           : c?.variant === "teal"   ? "var(--wd-teal)"
                           : "var(--wd-blue)";
            return (
              <div key={i} style={{ display:"flex", gap:12 }}>
                <div style={{ display:"flex", flexDirection:"column", alignItems:"center", flexShrink:0 }}>
                  <div style={{
                    width:10, height:10, borderRadius:"50%",
                    background:dotColor, marginTop:3,
                    boxShadow: isLatest ? `0 0 0 3px ${dotColor}33` : "none",
                  }} />
                  {i < arr.length - 1 && (
                    <div style={{ width:1, flex:1, background:"var(--wd-border)", minHeight:20, margin:"3px 0" }} />
                  )}
                </div>
                <div style={{ paddingBottom:16, flex:1 }}>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:8 }}>
                    <div style={{ display:"flex", alignItems:"center", gap:6 }}>
                      <span style={{ fontSize:13, fontWeight:600, color:"var(--wd-t1)" }}>
                        {c?.label || e.status.replace(/_/g," ")}
                      </span>
                      {isLatest && (
                        <span style={{ fontSize:9, fontWeight:700, padding:"1px 6px", borderRadius:10,
                          background:"rgba(59,130,246,.15)", color:"var(--wd-blue)", textTransform:"uppercase" }}>
                          Current
                        </span>
                      )}
                    </div>
                    <span style={{ fontSize:11, color:"var(--wd-t3)", whiteSpace:"nowrap", flexShrink:0 }}>
                      {formatDateTime(e.at)}
                    </span>
                  </div>
                  {e.note && (
                    <div style={{ fontSize:12, color:"var(--wd-t2)", marginTop:3, lineHeight:1.5 }}>{e.note}</div>
                  )}
                  <div style={{ fontSize:11, color:"var(--wd-t3)", marginTop:2 }}>by {e.by}</div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </Modal>
  );
}
export default ClaimDetailModal;
